import {authMiddleware} from "./loginAction";
import cfg, {handleResponse, handlePrepareData} from "../constants";

// rolesAction - get roles
export const rolesAction = (filter, signal) => (dispatch, getState) => {
    const headers = authMiddleware(dispatch, getState);
    return fetch(cfg.base_url + '/ba/role-list', { // Updated endpoint
        method: "POST",
        body: JSON.stringify(filter),
        headers,
        signal
    }).then(handleResponse).then(handlePrepareData);
};

// roleGetAction - get role by ID
export const roleGetAction = (id) => (dispatch, getState) => {
    const headers = authMiddleware(dispatch, getState);
    return fetch(cfg.base_url + '/ba/role/' + id, { // Updated endpoint
        method: "GET",
        headers
    }).then(handleResponse).then((data) => {
        if (data.status === 'ok') {
            return data.item; // Updated to reflect role
        }
        if (data.errors && data.errors.length > 0) {
            throw new Error(data.errors[0]);
        }
        throw new Error('error_other');
    });
};

// roleDeleteAction - delete role by ID
export const roleDeleteAction = (id) => (dispatch, getState) => {
    const headers = authMiddleware(dispatch, getState);
    return fetch(cfg.base_url + '/ba/role/' + id, { // Updated endpoint
        method: "DELETE",
        headers
    }).then(handleResponse).then(handlePrepareData);
};

// roleEditAction - edit role profile
export const roleEditAction = (item) => (dispatch, getState) => {
    const headers = authMiddleware(dispatch, getState);
    return fetch(cfg.base_url + '/ba/role', {
      method: "POST",
      headers,
      body: JSON.stringify(item)
    }).then(handleResponse).then(handlePrepareData);
  };


  // permissionsAction - get permissions
export const permissionsAction = (filter, signal) => (dispatch, getState) => {
    const headers = authMiddleware(dispatch, getState);
    return fetch(cfg.base_url + '/ba/permission-list', { // Updated endpoint
        method: "POST",
        body: JSON.stringify(filter),
        headers,
        signal
    }).then(handleResponse).then(handlePrepareData);
};

// permissionGetAction - get permission by ID
export const permissionGetAction = (id) => (dispatch, getState) => {
    const headers = authMiddleware(dispatch, getState);
    return fetch(cfg.base_url + '/ba/permission/' + id, { // Updated endpoint
        method: "GET",
        headers
    }).then(handleResponse).then((data) => {
        if (data.status === 'ok') {
            return data.item; // Updated to reflect role
        }
        if (data.errors && data.errors.length > 0) {
            throw new Error(data.errors[0]);
        }
        throw new Error('error_other');
    });
};

// permissionDeleteAction - delete permission by ID
export const permissionDeleteAction = (id) => (dispatch, getState) => {
    const headers = authMiddleware(dispatch, getState);
    return fetch(cfg.base_url + '/ba/permission/' + id, { // Updated endpoint
        method: "DELETE",
        headers
    }).then(handleResponse).then(handlePrepareData);
};

// permissionEditAction - edit permission profile
export const permissionEditAction = (item) => (dispatch, getState) => {
    const headers = authMiddleware(dispatch, getState);
    return fetch(cfg.base_url + '/ba/permission', {
      method: "POST",
      headers,
      body: JSON.stringify(item)
    }).then(handleResponse).then(handlePrepareData);
  };


  // rolePermissionsAction - get role permissions by ID
export const rolePermissionsAction = (id) => (dispatch, getState) => {
    const headers = authMiddleware(dispatch, getState);
    return fetch(cfg.base_url + '/ba/role-permission-list/' + id, { // Updated endpoint
        method: "POST",
        headers
    }).then(handleResponse).then((data) => {
        if (data.status === 'ok') {
            return data.list; // Updated to reflect role
        }
        if (data.errors && data.errors.length > 0) {
            throw new Error(data.errors[0]);
        }
        throw new Error('error_other');
    });
};

// rolePermissionEditAction - edit role permission profile
export const rolePermissionEditAction = (item) => (dispatch, getState) => {
    const headers = authMiddleware(dispatch, getState);
    return fetch(cfg.base_url + '/ba/role-permission', {
      method: "POST",
      headers,
      body: JSON.stringify(item)
    }).then(handleResponse).then(handlePrepareData);
  };
